<p-table id="custom-table-container" [value]="data" [columns]="columns" [reorderableColumns]="editFormat"
  (onColReorder)="onColumnReorder()" styleClass="p-datatable-sm" showGridlines>
  <ng-template #header let-columns>
    <tr>
      <th *ngFor="let col of columns" pReorderableColumn [id]="'th-' + idMap[col.field].id + '-' + documentId"
        (click)="clickTable($event)" [class]=" idMap[col.field].id">
        {{ col.header }}
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-rowData let-columns="columns" let-index="rowIndex">
    <tr [pReorderableRow]="index">
      <td *ngFor="let col of columns" [id]="'td-' + idMap[col.field].id + '-' + rowData.id"
        (click)="clickTable($event)">
        {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat}}
      </td>
    </tr>
  </ng-template>

  <ng-template *ngIf="footerVisible" pTemplate="footer">
    <tr>
      <td *ngFor="let col of columns" [id]="'td-' + idMap[col.field].id + '-footer-' + documentId"
        (click)="clickTable($event)">
        <ng-container *ngIf="idMap[col.field].showTotal">
          {{ getTotal(col.field) | dynamicFormatPipe: idMap[col.field].type : idMap[col.field].printFormat }}
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>